/**
 * Validates a username according to the application's requirements
 * @param username - The username to validate
 * @returns An object with isValid boolean and error message (if invalid)
 */
export interface UsernameValidationResult {
    isValid: boolean;
    error?: string;
}

export const validateUsername = (username: string): UsernameValidationResult => {
    // Check if username is empty
    if (!username.trim()) {
        return {
            isValid: false,
            error: 'Username is required',
        };
    }

    // Check minimum length
    if (username.length < 4) {
        return {
            isValid: false,
            error: 'Username must be at least 4 characters long',
        };
    }

    // Check maximum length
    if (username.length > 20) {
        return {
            isValid: false,
            error: 'Username cannot be more than 20 characters long',
        };
    }

    // Check for spaces
    if (username.includes(' ')) {
        return {
            isValid: false,
            error: 'Username cannot contain spaces',
        };
    }

    // Check for ASCII letters and numbers only
    const asciiRegex = /^[a-zA-Z0-9]+$/;
    if (!asciiRegex.test(username)) {
        return {
            isValid: false,
            error: 'Username can only contain letters and numbers',
        };
    }

    return {
        isValid: true,
    };
};
